<div class="goals-container">
  <!-- Title Section -->
  <div class="title-section">
    <h3 class="section-title">Goals</h3>
    <button class="edit-btn" (click)="onEditClick()">
      <span class="edit-text">Edit</span>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.99935 4.33321L11.666 6.99988M2.66602 13.3332H5.33268L12.3327 6.33321C12.5078 6.15811 12.6467 5.95024 12.7414 5.72147C12.8362 5.4927 12.885 5.2475 12.885 4.99988C12.885 4.75225 12.8362 4.50705 12.7414 4.27828C12.6467 4.04951 12.5078 3.84164 12.3327 3.66654C12.1576 3.49145 11.9497 3.35255 11.7209 3.25779C11.4922 3.16303 11.247 3.11426 10.9993 3.11426C10.7517 3.11426 10.5065 3.16303 10.2778 3.25779C10.049 3.35255 9.84111 3.49145 9.66602 3.66654L2.66602 10.6665V13.3332Z" stroke="#1B5BFF" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        
    </button>
  </div>

  <!-- Goals List -->
  <div class="goals-list">
    <div *ngFor="let goal of goals; let i = index; trackBy: trackByIndex" class="goal-card">
      <!-- Goal Header -->
      <div class="goal-header">
        <div class="goal-title-section">
          <h4 class="goal-name">Goal {{ i + 1 }}</h4>
        </div>
      </div>
      
      <!-- Divider -->
      <div class="divider"></div>
      
      <!-- Detailed Goal Information Grid -->
      <div class="goal-details-grid">
        <!-- Row 1 -->
        <div class="detail-row">
          <div class="detail-item">
            <span class="detail-label">GOAL NAME</span>
            <span class="detail-value">{{ goal.name }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">EVENT</span>
            <span class="detail-value">{{ removeUnderscores(goal.event) }}</span>
          </div>
        </div>
        
        <!-- Row 2 -->
        <div class="detail-row">
          <div class="detail-item">
            <span class="detail-label">ACHIEVED / TARGET VALUE</span>
            <span class="detail-value">{{ goal.achieved }} / {{ goal.target }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">TIMEFRAME</span>
            <span class="detail-value">{{ removeUnderscores(goal.timeframe) }}</span>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="goals.length === 0" class="empty-state">
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M32 8C18.745 8 8 18.745 8 32s10.745 24 24 24 24-10.745 24-24S45.255 8 32 8zm0 40c-8.837 0-16-7.163-16-16s7.163-16 16-16 16 7.163 16 16-7.163 16-16 16z" fill="#E9EAEC"/>
        <path d="M32 20v24M20 32h24" stroke="#A7ABB3" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <h4 class="empty-title">No goals set</h4>
      <p class="empty-description">Set your first goal to track campaign performance and success metrics.</p>
      
    </div>
  </div>

  <!-- Empty State -->
  
</div>
